import {RemotePatchUpdatePhone} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {ProfileChangeDataEndpoints} from 'main/factories/usecases/endpoints';
import {PatchUpdatePhone} from 'domain/usecases';

export const makePatchUpdatePhone = (): PatchUpdatePhone =>
	new RemotePatchUpdatePhone(
		makeBFFApiUrl(ProfileChangeDataEndpoints.checkCellPhone),
		makeAuthorizeHttpClientDecorator(),
	);
